import api from '../..'

export async function deleteTemplate(
  campaignId: string,
  templateId: string,
): Promise<void> {
  await api.delete(`/campaigns/${campaignId}/templates/${templateId}`)
}
